<template>
  <div class="relative flex flex-col justify-between h-full w-full bg-grey-300">
    <div id="invitation-style" class="flex flex-col container mx-auto lg:px-4 xl:px-12">
      <h1 class="text-5xl leading-none mt-10 font-bold border-2 bg-white py-6">INVITATION</h1>

      <div id="pdf-boxes-container" class="flex mt-20 xl:mt-40 w-full h-72">
        <div class="flex flex-col relative w-1/4 h-full border-2 bg-white mr-10 ml-auto cursor-pointer" @click="showPdf('invitation_1')">
          <div class="flex border-b h-16 heading-container w-10/12 mx-auto mt-2">
            <h2 class="m-auto text-2xl">PROLOG</h2>
          </div>
          <h2 class="mt-6 text-xl font-bold leading-tight tracking-widest">The Idea <br>of Inside Media</h2>
          <div class="absolute bottom-0 flex w-full">
            <p class="text-3xl font-bold mx-auto mb-2">PDF</p>
          </div>
        </div>
        <div class="flex flex-col relative w-1/4 h-full border-2 bg-white mr-10 cursor-pointer" @click="showPdf('invitation_2')">

          <div class="flex border-b h-16 heading-container w-10/12 mx-auto mt-2">
            <h2 class="m-auto text-2xl">STRATEGY</h2>
          </div>

          <h2 class="mt-6 text-xl font-bold leading-tight tracking-widest">The 2nd<br> half in the game <br> of Social Media</h2>
          <div class="absolute bottom-0 flex w-full">
            <p class="text-3xl font-bold mx-auto mb-2">PDF</p>
          </div>
        </div>
        <div class="flex flex-col relative w-1/4 h-full border-2 bg-white mr-10 cursor-pointer" @click="showPdf('invitation_3')">
          <div class="flex border-b h-16 heading-container w-10/12 mx-auto mt-2">
            <h2 class="m-auto text-2xl">APPENDIX</h2>
          </div>

          <h2 class="mt-6 text-xl font-bold leading-tight tracking-widest">The evolution<br> of the functions <br> of Social Media</h2>
          <div class="absolute bottom-0 flex w-full">
            <p class="text-3xl font-bold mx-auto mb-2">PDF</p>
          </div>
        </div>
        <div class="flex flex-col relative w-1/4 h-full border-2 bg-white mr-auto cursor-pointer" @click="showPdf('invitation_4')">
          <div class="flex border-b h-16 heading-container w-10/12 mx-auto mt-2">
            <h2 class="m-auto text-2xl">EXCERPTS</h2>
          </div>

          <h2 class="mt-6 text-xl font-bold leading-tight tracking-widest">Most important<br> extracts from <br> the theory</h2>
          <div class="absolute bottom-0 flex w-full">
            <p class="text-3xl font-bold mx-auto mb-2">PDF</p>
          </div>
        </div>
      </div>
    </div>

    <Navigation />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import {mapState} from "vuex";

export default {
  name: "InvitationComponent",
  components:{
    Navigation
  },
  data(){
    return{
      invitation_1: 'invitation/PROLOG+-+The+Idea+of+Inside+Media.pdf',
      invitation_2: 'invitation/STRATEGY+-+The+2nd+half+in+the+game+of+social+media.pdf',
      invitation_3: 'invitation/APPENDIX+-+The+evolution+of+the+functions+of+social+media.pdf',
      invitation_4: 'invitation/EXCERPTS+-+Most+important+excerpts+from+the+theory.pdf',
    }
  },
  methods:{
    showPdf(pdf){
      window.open(this.pdfBaseUrl + this[pdf]);
    }
  },
  computed: {
   ...mapState(["pdfBaseUrl"])
 }
}
</script>

<style lang="css" scoped>

@media (min-width: 1024px){

#pdf-boxes-container{

margin-top: 5rem;
}

}

@media (min-width: 1280px){

#pdf-boxes-container{
  margin-top: 5rem;
}

}

@media (min-width: 1367px){

#pdf-boxes-container{
  margin-top: 10rem;
}

}

@media (min-width: 2000px){

#pdf-boxes-container{
  margin-top: 15rem;
}

}
</style>
